import { useBrandingsStore } from '@web/components/utils/branding/useBrandingsStore'
import { useMemo } from 'react'
import { RGBColor } from 'react-color'

export const toRgbString = (color: RGBColor) => {
  const { r, g, b, a } = color
  return `rgb(${r}, ${g}, ${b}, ${a})`
}

export const toBrandCssVariable = (key: string) => {
  return `--branding-color-${key.split(' ').join('-').toLowerCase().replace('#', '\\#')}`
}

export const useColorWithOpacity = (color: string | null, opacity: string | null, defaultColor?: string) => {
  const colors = useBrandingsStore((state) => state.colorData)
  return useMemo(() => {
    // means this is a branding key color
    if (color && !color.includes('#') && !colors?.[color] && !defaultColor) {
      return `var(${toBrandCssVariable(color)})`
    }

    if (!color) {
      return colors?.[defaultColor ?? ''] ?? defaultColor ?? 'transparent'
    }

    if (!opacity || Number(opacity) === 1) {
      return colors?.[color] ? `var(${toBrandCssVariable(color)})` : color
    }

    let opacityHex = Math.round(parseFloat(opacity) * 255)
      .toString(16)
      .toUpperCase()

    opacityHex = opacityHex.length === 1 ? `0${opacityHex}` : opacityHex

    return `${colors?.[color] ?? color}${opacityHex}`
  }, [color, opacity, colors, defaultColor])
}

export const BRAND_KEY = 'Brand'
export const TEXT_DARK_KEY = 'Text dark'
